import { motion } from "framer-motion";
import { SITE } from "../data/site";

const EASE = [0.22, 1, 0.36, 1];

const Hero = () => (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden">
        <img
            src="/assets/logo-emblem.png"
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -left-8 top-32 h-44 w-44 opacity-[0.08]"
        />
        <img
            src="/assets/logo-emblem.png"
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -right-10 bottom-16 h-52 w-52 rotate-45 opacity-[0.08]"
        />
        <div className="mx-auto max-w-7xl px-6 pb-28 pt-40 md:px-12 lg:pb-40 lg:pt-48">
            <div className="max-w-3xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.25, ease: EASE }}
                >
                    <h1 className="sr-only">Paan Saga — 100% Tobacco Free, Himayatnagar Hyderabad</h1>
                    <img
                        src="/assets/logo-full.png"
                        alt="Paan Saga — 100% Tobacco Free"
                        data-testid="hero-logo"
                        className="mt-10 w-full max-w-sm sm:max-w-md"
                    />
                </motion.div>

                <motion.p
                    className="mt-8 font-display text-2xl italic text-saga-ink sm:text-3xl"
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4, ease: EASE }}
                >
                    {SITE.tagline}
                </motion.p>

                <motion.p
                    className="mt-3 text-base text-saga-ink/70 sm:text-lg"
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.5, ease: EASE }}
                >
                    {SITE.subTagline}
                </motion.p>

                <motion.div
                    className="mt-10 flex flex-wrap items-center gap-4"
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6, ease: EASE }}
                >
                    <a
                        href="#menu"
                        data-testid="hero-explore-menu-btn"
                        className="rounded-full bg-saga-red px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-cream transition-colors hover:bg-saga-reddeep"
                    >
                        Explore the Menu
                    </a>
                    <a
                        href="#story"
                        data-testid="hero-our-story-btn"
                        className="rounded-full border border-saga-red px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-red transition-colors hover:bg-saga-red hover:text-saga-cream"
                    >
                        Our Story
                    </a>
                </motion.div>
            </div>
        </div>
    </section>
);

export default Hero;
